<template>
  <div class="rBox">
    <el-form label-width="90px">
      <!-- <el-form-item label="风格">
          <template>
            <el-radio v-model="curSelData.scanStyle" :label="1">风格一</el-radio>
            <el-radio v-model="curSelData.scanStyle" :label="2">风格二</el-radio>
          </template>
      </el-form-item> -->
      <el-form-item label="上下边距">
        <template>
          <bs-slider v-model="curSelData.paddTop" :min="0" :max="100" />
        </template>
      </el-form-item>
      <el-form-item label="左右边距">
        <template>
          <bs-slider v-model="curSelData.paddLeft" :min="0" :max="100" />
        </template>
      </el-form-item>
      <el-form-item label="二维码背景">
            <el-input v-model="curSelData.scanBg" placeholder="请输入图片地址">
            <template slot="append"><span style="cursor: pointer" @click="selImg('scanForKNF','scanBg')">选择图片</span></template>
          </el-input>
      </el-form-item>
      <el-form-item label="背景颜色" class="formsItem">
        <template>
          <bs-color-picker v-model="curSelData.bgColor" style="float:left;" />
          <el-button type="primary" class="btnClear" @click="clearColor('bgColor')">清除</el-button>
        </template>
      </el-form-item>

      <el-form-item label="背景图片">
          <el-input v-model="curSelData.boxBg" placeholder="请输入图片地址">
            <template slot="append"><span style="cursor: pointer" @click="selImg('scanForKNF','boxBg')">选择图片</span></template>
          </el-input>
        <el-col :span="18">
          <img :src="curSelData.boxBg" alt="" class="imgClass">
        </el-col>
      </el-form-item>
       <el-form-item label="标题颜色" class="formsItem">
        <template>
          <bs-color-picker v-model="curSelData.keyColor" style="float:left;" />
          <el-button type="primary" class="btnClear" @click="clearColor('keyColor')">清除</el-button>
        </template>
      </el-form-item>
       <el-form-item label="内容颜色" class="formsItem">
        <template>
          <bs-color-picker v-model="curSelData.valueColor" style="float:left;" />
          <el-button type="primary" class="btnClear" @click="clearColor('valueColor')">清除</el-button>
        </template>
      </el-form-item>
      <el-form-item label="标题1颜色" class="formsItem">
        <template>
          <bs-color-picker v-model="curSelData.title1Color" style="float:left;" />
          <el-button type="primary" class="btnClear" @click="clearColor('title1Color')">清除</el-button>
        </template>
      </el-form-item>
      <el-form-item label="标题1文字" class="formsItem">
        <template>
           <el-input v-model="curSelData.title1" placeholder="请输入标题1文字" style="margin-top: 10px"/>
        </template>
      </el-form-item>
       <el-form-item label="标题2颜色" class="formsItem">
        <template>
          <bs-color-picker v-model="curSelData.title2Color" style="float:left;" />
          <el-button type="primary" class="btnClear" @click="clearColor('title2Color')">清除</el-button>
        </template>
      </el-form-item>
      <el-form-item label="标题2文字" class="formsItem">
        <template>
           <el-input v-model="curSelData.title2" placeholder="请输入标题2文字" style="margin-top: 10px"/>
        </template>
      </el-form-item>
        <el-card v-for="(item,index) in curSelData.list" :key="item.name" class="pageCard">
          <div slot="header" class="clearfix">
            <el-button style="float: right; padding: 3px 0" type="text" @click="delItem(index)">删除</el-button>
          </div>
          <el-row>
              <el-form-item label="名称">
                  <el-input v-model="item.name" placeholder="请输入名称" style="margin-top: 10px">
                  </el-input>
              </el-form-item>
          </el-row>
          <el-row>
              <el-form-item label="内容">
                  <el-input v-model="item.value" placeholder="请输入内容" style="margin-top: 10px">
                  </el-input>
              </el-form-item>
          </el-row>
        </el-card>
        <el-button style="margin:20px auto;width: 80%;display: block" @click="addItem">添加按钮</el-button>


    </el-form>
  </div>
</template>
<script>
import BsSlider from '../module/BsSlider'
import BsColorPicker from '../module/BsColorPicker'
export default {
  components: {
    BsSlider,
    BsColorPicker
  },
  props: {
    curSelData: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {}
    }
  },
  data() {
    return {
      oneDefault: {
        name: '',
        value:'',
      }
    }
  },
  methods: {
    clearColor(attr) {
      this.curSelData[attr] = 'transparent'
    },
    selImg(type, attr) {
      this.$emit('selImg', type, attr)
    },
    addItem() {
      this.curSelData.list.push(this.oneDefault)
    },
    delItem(index) {
      this.curSelData.list.splice(index, 1)
    },
  }
}
</script>
<style scoped>
  .imgClass{
    width: 200px;
    height: auto;
    margin: 15px 0;
  }
</style>
